import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import { TransparentButton } from '../Button/TransparentButton';

export const CollapsibleSectionContainer = styled(TransparentButton)`
  width: 100%;
  outline: none;
`;

export const CollapsedSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ChevronSVG = styled(props => <InlineSVG {...props} />)`
  padding-left: ${props => props.theme.space['0.5']};
  svg {
    path {
      fill: ${props => props?.fillColor || props.theme.colors.capsuleBlue50};
    }

    width: 2rem;
    height: 2rem;
  }
`;
